module.exports = __webpack_public_path__ + "static/media/clipboard-list.b6bb4deb.svg";